import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthenticated } from '../auth/authSlice';
import Login from '../auth/Login';
import ListaPlataformas from './ListaPlataformas';
import { loadPlataformas } from './plataformaSlice';



export default function AdminPlataformas () {
    const navigate = useNavigate();
    const userAuthenticated = useSelector(selectAuthenticated);
    const dispatch = useDispatch();
    
    useEffect(() => {
        loadList();
    }, []);
    
    function loadList(){
        dispatch(loadPlataformas());
    }
    
    if (!userAuthenticated) {
        return <Login />;
    }

    return (
        <> 
            <div className='title'>
                <h2>Administración de responsables de plataforma</h2>
            </div>
            <button id='volver' onClick={() => navigate(-1)}>Atrás</button>
            <ListaPlataformas />
        </>
    );
}